<div class="konbini-item">
  <svg-icon
    class="konbini-item__icon"
    src="/assets/images/icons/book-photo-step-recomendation-icon.svg"
  ></svg-icon>
  <div class="konbini-item__content"><ng-content></ng-content></div>
</div>
